import { useState } from 'react';
import { Layout } from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { OrcamentoTab } from './OrcamentoTab';
import { CatalogoTab } from './CatalogoTab';
import { HistoricoTab } from './HistoricoTab';
import { useOrcamentoDraft } from './draftStore';

export function Orcamentos() {
  const [tab, setTab] = useState('orcamento');
  const loadDraft = useOrcamentoDraft((s) => s.loadDraft);

  return (
    <Layout breadcrumbs={[{ label: 'Orçamentos' }]}>
      <div className="flex flex-col gap-4 p-3 sm:p-4 lg:gap-6 lg:p-6">
        <div>
          <h1 className="max-md:hidden text-2xl font-bold tracking-tight text-text-title sm:text-3xl">
            Orçamentos
          </h1>
          <p className="mt-1 text-sm text-text-secondary">
            Monte a proposta do kit RFID passo a passo. O total ao lado atualiza enquanto você
            preenche.
          </p>
        </div>

        <Tabs value={tab} onValueChange={setTab}>
          <TabsList>
            <TabsTrigger value="orcamento">Novo orçamento</TabsTrigger>
            <TabsTrigger value="salvos">Orçamentos salvos</TabsTrigger>
            <TabsTrigger value="catalogo">Catálogo de produtos</TabsTrigger>
          </TabsList>

          {/* forceMount: mantém o rascunho em memória ao alternar de aba */}
          <TabsContent value="orcamento" forceMount className="data-[state=inactive]:hidden">
            <OrcamentoTab />
          </TabsContent>

          <TabsContent value="salvos">
            <HistoricoTab
              onAbrir={(dados, id) => {
                loadDraft(dados, id);
                setTab('orcamento');
              }}
            />
          </TabsContent>

          <TabsContent value="catalogo">
            <CatalogoTab />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
